export const flattenEdges = (data: any, queryName: string) => {
  const edges = data?.[queryName]?.edges ?? [];
  return edges.map((edge: any) => edge.node);
};
